import UserTradingHistory from './UserTradingHistory';

export default UserTradingHistory;
